import { MediaPlaylist } from 'hls.js';
import { Reducer } from 'react';

import { MediaStateActions } from '../actions';
import { MediaElementActionPayload, MediaElementState } from '../types';

export const MediaStateReducer: Reducer<MediaElementState, MediaElementActionPayload> = (
  state: MediaElementState,
  action: MediaElementActionPayload,
): MediaElementState => {
  const { payload } = action;
  switch (action.type) {
    case MediaStateActions.UPDATE_MEDIA_ELEMENT_STATE: {
      return { ...state, ...(payload as MediaElementState) };
    }
    case MediaStateActions.UPDATE_CAN_PLAY: {
      return {
        ...state,
        canPlay: payload as boolean,
      };
    }
    case MediaStateActions.UPDATE_DURATION: {
      return {
        ...state,
        duration: payload as number,
      };
    }
    case MediaStateActions.UPDATE_CURRENT_TIME: {
      return {
        ...state,
        currentTime: payload as number,
      };
    }
    case MediaStateActions.UPDATE_VOLUME: {
      return {
        ...state,
        volume: payload as number,
      };
    }
    case MediaStateActions.UPDATE_IS_PAUSED: {
      return {
        ...state,
        isPaused: payload as boolean,
      };
    }
    case MediaStateActions.UPDATE_IS_MUTED: {
      return {
        ...state,
        isMuted: payload as boolean,
      };
    }
    case MediaStateActions.UPDATE_SEEKING: {
      return {
        ...state,
        seeking: payload as boolean,
      };
    }
    case MediaStateActions.UPDATE_TEXT_TRACKS: {
      return {
        ...state,
        textTracks: payload as TextTrackList,
      };
    }
    case MediaStateActions.UPDATE_SELECTED_SUBTITLE: {
      return {
        ...state,
        selectedSubtitle: payload as TextTrack,
      };
    }
    case MediaStateActions.UPDATE_SUBTITLES_ENABLED: {
      return {
        ...state,
        subtitleEnabled: payload as boolean,
      };
    }
    case MediaStateActions.UPDATE_AUDIO_TRACKS: {
      return {
        ...state,
        audioTracks: payload as MediaPlaylist[],
      };
    }
    case MediaStateActions.UPDATE_AUDIO_TRACK_INDEX: {
      return {
        ...state,
        audioTrackIndex: payload as number,
      };
    }
    default: {
      return { ...state };
    }
  }
};
